/* ProductPage - Router for product pages
 * Updated: Vite/React structure - routes to appropriate client component based on slug
 * Updated: Fixed variant URL generation to use database slug instead of manually constructing it
 */

import ProductPageClient from '@/components/product/ProductPageClient';

export default function ProductPage() {
  return <ProductPageClient />;
}
